import { render } from "./TransactionMain.vue?vue&type=template&id=19edd3a5&scoped=true"
import script from "./TransactionMain.vue?vue&type=script&lang=js"
export * from "./TransactionMain.vue?vue&type=script&lang=js"

import "./TransactionMain.vue?vue&type=style&index=0&id=19edd3a5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19edd3a5"]])

export default __exports__